export default __webpack_public_path__ + "static/media/bd.d4c28c92.mp3";